











































































import { Component, Vue, Prop } from 'vue-property-decorator';

import MobileSearchWidget       from '@/components/ui/MobileSearchWidget.vue';
import MapTrayFooter       from '@/components/map/MapTrayFooter.vue';

@Component({
  name: 'MobileMapTray',
  components: {
    MobileSearchWidget,
    MapTrayFooter
  }
})

export default class MobileMapTray extends Vue {

  @Prop({ required: true, default: false }) readonly hasStateContext!: boolean;
  @Prop({ required: false, default: '' }) readonly stateContextTitle!: string;

  @Prop({ required: true, default: false }) readonly hasBackRoute!: boolean;
  @Prop({ required: false, default: '' }) readonly backRoute!: string;

  get isTrayOpen() {
    return this.$store.state.uiState.isTrayOpen;
  }

  get isTrayExpanded() {

    // Or, when search results are showing
    //
    // 0. get rid of all this refs crap
    // 1. add a global flag in uiState... searchResultsActive or something
    // 2. then update that in shitty routing code in Main
    // 3. switch here, on and off of that

    // When autocomplete has focus (and therefore keyboard probably open?)
    return    this.$store.state.uiState.autocompleteHasFocus
           || this.$store.state.uiState.isSearchResultsRoute
           && this.isTrayOpen;
  }

  // TODO clean up, consolidate with above stuff
  get isSearchResultsRoute() {
    return this.$store.state.uiState.isSearchResultsRoute;
  }

  bubbleGeolocationError(event: Event) {
    this.$emit("geolocationerror")
  }

  toggleTray() {
    const nextState = !this.isTrayOpen;
    this.$store.dispatch('setIsTrayOpen', nextState);
  }

  handleCloseTray() {
    if (this.isTrayOpen){
      this.toggleTray();
    }
  }

  handleOpenTray() {
    if (!this.isTrayOpen){
      this.toggleTray();
    }
  }

}

